<div id="app" class="app">
    <!-- BEGIN login -->
    <div class="login login-v1">
        <!-- BEGIN login-container -->
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: center; align-items: center;">
            <div class="login-container">
                <!-- BEGIN login-header -->
                <div class="login-header">
                    <div class="brand">
                        <div class="col-12 d-flex justify-content-evenly">
                            <img src="../../../assets/img/logo-prodynamics.png" class="logos-login" alt="">
                            <img src="../../../assets/img/cover-sidebar.png" class="logos-login" style="filter: drop-shadow(0px 0px 2px rgba(124, 124, 124, 0.7));" alt="">
                            <!-- <b class="me-1">{{appTitleHeaderStrong}}</b> -->
                            
                        </div>
                        
                    </div>
                    <!-- <div class="icon">
                        <i class="fa fa-lock"></i>
                    </div> -->
                </div>
                <!-- END login-header -->
                
                <!-- BEGIN login-body -->
                <div class="login-body">
                    <!-- BEGIN login-content -->
                    <div class="login-content fs-13px">
                        <!-- <form action="index.html" method="GET">-->
                            <small>Acceso al sistema, escriba sus credenciales</small>
                            <form [formGroup]="loginForm">
                                <div class="form-floating mb-20px">
                                    <input type="text" formControlName="cuenta" class="form-control fs-13px h-45px" placeholder="Email Address" name="Cuenta" (input)="Cuenta=$event.target.value" value="{{Cuenta}}">
                                    <label for="emailAddress" class="d-flex align-items-center">Cuenta de acceso</label>
                                </div>
                                <div class="form-floating mb-20px">
                                    <input type="password" formControlName="password" class="form-control fs-13px h-45px" placeholder="Password" name="Password"  (input)="Password=$event.target.value" value="{{Password}}">
                                    <label for="password" class="d-flex align-items-center">Contraseña</label>
                                </div>
                                <!--
                                <div class="form-check mb-20px">
                                    <input class="form-check-input" type="checkbox" value="" id="rememberMe">
                                    <label class="form-check-label" for="rememberMe">
                                        Remember Me
                                    </label>
                                </div>
                                -->
                                <div class="login-buttons">
                                    <button [disabled]="!loginForm.valid" class="btn btn-primary h-45px d-block w-100 btn-lg" (click)="ngClickAccess()" [disabled]="loadingLogin">
                                        <span *ngIf="!loadingLogin">Acceder</span>
                                        <span *ngIf="loadingLogin">
                                            <i class="fas fa-sync-alt fa-spin" style="color: white;"></i>
                                        </span>
                                    </button>
                                </div>
                                <div *ngIf="!credencialesValidas" class="d-flex justify-content-center align-items-center w-100">
                                    <span class="error-login-text">Credenciales Invalidas</span>
                                </div>
                            </form>
                            
                        <!--</form>-->
                    </div>
                    
                    <!-- END login-content -->
                </div>
                <div class="d-flex flex-column align-items-center" style="margin-top: 40px;">
                    <span class="text-white text-center">Tires & Wheels Expenses - Powered by</span>
                    
                    <img class="prodx-icon" src="../../../assets/img/prodx-logo-1x.png">
                </div>

                <img src="../../../assets/img/tex.png" class="logos-tex" alt="">
                <img src="../../../assets/img/money-bank.png" class="logo-wheels" alt="">
                <!-- END login-body -->
            </div>
            
            <!-- <div class="row text-center">
                <span class="text-white">Powered by <b>ProDX</b></span>
                <br>
                <img class="prodx-icon" src="../../../assets/icons/llantas.webp">
            </div> -->
        </div>
        <!-- END login-container -->
    </div>
    <!-- END login -->
    
   
    <!-- BEGIN scroll-top-btn -->
   <!-- <a href="javascript:;" class="btn btn-icon btn-circle btn-theme btn-scroll-to-top" data-toggle="scroll-to-top"><i class="fa fa-angle-up"></i></a>-->
    <!-- END scroll-top-btn -->
</div>